/** The editable wording of one email. Mirrors the server's template content. */
export interface TemplateContent {
  subject: string;
  preheader: string;
  heading: string;
  bodyParagraphs: string[];
  ctaLabel: string | null;
}

/**
 * Whether two wordings are the same. Compared field by field: stored content
 * and registry defaults do not list their keys in the same order, so a JSON
 * string comparison would call identical wording different.
 */
export function sameTemplateContent(a: TemplateContent, b: TemplateContent): boolean {
  return (
    a.subject === b.subject &&
    a.preheader === b.preheader &&
    a.heading === b.heading &&
    (a.ctaLabel ?? null) === (b.ctaLabel ?? null) &&
    a.bodyParagraphs.length === b.bodyParagraphs.length &&
    a.bodyParagraphs.every((p, i) => p === b.bodyParagraphs[i])
  );
}
